type BackOrderImagePreviewPopupProps = {
  imageUrl: string;
  title: string;
  onClose: () => void;
};

export default function BackOrderImagePreviewPopup({
  imageUrl,
  title,
  onClose,
}: BackOrderImagePreviewPopupProps) {
  return (
    <div className="back-order-large-image-overlay">
      <div className="back-order-large-image-popup" role="dialog" aria-modal="true">
        <button
          type="button"
          className="back-order-large-image-close"
          aria-label="Close image preview"
          onClick={onClose}
        >
          <i className="ic-clearclose"></i>
        </button>

        <div className="back-order-large-image-frame">
          <img src={imageUrl} alt={title} />
        </div>
      </div>
    </div>
  );
}
